module.exports = __webpack_public_path__ + "static/media/fresh.6a71ed17.png";